<template>
    <span>
        <v-navigation-drawer
            v-if="isAuthenticated"
            v-model="showDrawer"
            hide-overlay
            app
            dark
            :src="backgroundMenu"
            :color="sideBarColor"
            clipped
            class="elevation-2"
        >
            <v-list dense data-cy="drawerList">
                <v-list-item v-model="isAuthenticated" two-line>
                    <v-list-item-avatar
                        :class="
                            computedGetPartner
                                ? 'grey--text text--darken-2'
                                : ''
                        "
                        :style="sidebarTextStyle"
                    >
                        <v-icon dark>mdi-account-circle</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title
                            class="title"
                            :class="
                                computedGetPartner
                                    ? 'grey--text text--darken-2'
                                    : ''
                            "
                            :style="sidebarTextStyle"
                            >{{ computedGetUserName }}</v-list-item-title
                        >
                        <v-list-item-subtitle
                            :class="
                                computedGetPartner
                                    ? 'grey--text text--darken-2'
                                    : ''
                            "
                            :style="sidebarTextStyle"
                            >{{ computedGetUserLogin }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle v-if="usuarioAgrupador"
                            >Agrupador:
                            {{ usuarioAgrupador }}</v-list-item-subtitle
                        >
                        <div
                            v-if="superUsuario"
                            class="justify-center align-center py-2 px-0"
                            style="display: grid; gap: 8px"
                        >
                            <v-btn
                                widht="100%"
                                x-small
                                color="primary"
                                style="display: flex; justify-content: left;"
                            >
                                <v-icon x-small class="ma-1 white--text"
                                    >mdi-checkbox-marked-circle</v-icon
                                >
                                Super Usuário
                            </v-btn>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        v-if="apresentanteNotifica"
                                        widht="100%"
                                        x-small
                                        color="primary"
                                        style="display: flex; justify-content: center;"
                                    >
                                        <v-icon x-small class="ma-1 white--text"
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                        Notifica
                                    </v-btn>
                                </template>
                                <span>
                                    {{
                                        `Apresentante ${computedGetApresentante} habilitado na Notifica!`
                                    }}
                                </span>
                            </v-tooltip>
                        </div>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="grey lighten-2"></v-divider>

                <!-- Menu para usuário Recuperi -->
                <template v-if="usuarioRecuperi">
                    <template v-for="item in menusRecuperi">
                        <v-list-group
                            v-if="
                                item.childs && isShowItem(item, isAuthenticated)
                            "
                            :key="item.text"
                            :data-cy="getValorDataCypress(item)"
                            color="white"
                            :style="sidebarTextStyle"
                        >
                            <template v-slot:appendIcon>
                                <v-icon :style="sidebarTextStyle">
                                    mdi-chevron-down
                                </v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-icon :style="sidebarTextStyle">
                                    <v-btn
                                        style="height: 24px"
                                        elevation="0"
                                        fab
                                        text
                                        small
                                        :loading="loadingIcon"
                                    >
                                        <v-icon :style="sidebarTextStyle">{{
                                            item.icon
                                        }}</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-title :style="sidebarTextStyle">
                                    {{ item.text }}
                                </v-list-item-title>
                            </template>
                            <template v-for="child in item.childs">
                                <v-list-item
                                    v-if="isShowItem(child, isAuthenticated)"
                                    :key="child.text"
                                    :to="child.path"
                                    :data-cy="getValorDataCypress(child)"
                                    :style="sidebarTextStyle"
                                >
                                    <v-btn
                                        style="height: 24px"
                                        elevation="0"
                                        fab
                                        text
                                        small
                                        :loading="loadingIcon"
                                    >
                                        <v-icon :style="sidebarTextStyle">{{
                                            child.icon
                                        }}</v-icon>
                                    </v-btn>
                                    <v-list-item-title
                                        :style="sidebarTextStyle"
                                    >
                                        {{ child.text }}
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-item
                            v-else-if="isShowItem(item, isAuthenticated)"
                            :key="item.text"
                            :to="item.path"
                            :data-cy="getValorDataCypress(item)"
                            :style="sidebarTextStyle"
                        >
                            <v-btn
                                elevation="0"
                                fab
                                text
                                small
                                :loading="loadingIcon"
                            >
                                <v-icon :style="sidebarTextStyle">{{
                                    item.icon
                                }}</v-icon>
                            </v-btn>
                            <v-list-item-title :style="sidebarTextStyle">{{
                                item.text
                            }}</v-list-item-title>
                        </v-list-item>
                    </template>
                </template>

                <!-- Menu para usuário Partner -->
                <template v-if="usuarioPartner">
                    <template v-for="item in menusPartner">
                        <v-list-group
                            v-if="
                                item.childs && isShowItem(item, isAuthenticated)
                            "
                            :key="item.text"
                            :data-cy="getValorDataCypress(item)"
                            color="white"
                            append-icon="mdi-chevron-down"
                            append-icon-cb
                        >
                            <template v-slot:appendIcon>
                                <v-icon class="grey--text text--darken-2">
                                    mdi-chevron-down
                                </v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-btn
                                        style="height: 24px"
                                        elevation="0"
                                        fab
                                        text
                                        small
                                        :loading="loadingIcon"
                                        class="grey--text text--darken-2"
                                    >
                                        <v-icon>{{ item.icon }}</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-title
                                    class="grey--text text--darken-2"
                                >
                                    {{ item.text }}
                                </v-list-item-title>
                            </template>
                            <template v-for="child in item.childs">
                                <v-list-item
                                    v-if="isShowItem(child, isAuthenticated)"
                                    :key="child.text"
                                    :to="child.path"
                                    :data-cy="getValorDataCypress(child)"
                                    class="grey--text text--darken-2"
                                >
                                    <v-btn
                                        style="height: 24px"
                                        elevation="0"
                                        fab
                                        text
                                        small
                                        :loading="loadingIcon"
                                    >
                                        <v-icon>{{ child.icon }}</v-icon>
                                    </v-btn>
                                    <v-list-item-title>
                                        {{ child.text }}
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-item
                            v-else-if="isShowItem(item, isAuthenticated)"
                            :key="item.text"
                            :to="item.path"
                            :data-cy="getValorDataCypress(item)"
                            class="grey--text text--darken-2"
                            active-class="grey lighten-5"
                        >
                            <v-btn
                                elevation="0"
                                fab
                                text
                                small
                                :loading="loadingIcon"
                                color="grey darken-2"
                            >
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-btn>
                            <v-list-item-title>{{
                                item.text
                            }}</v-list-item-title>
                        </v-list-item>
                    </template>
                </template>
                <template>
                    <v-list-item
                        key="password"
                        @click="minhaConta"
                        v-show="$vuetify.breakpoint.xs && !isSocialUser"
                    >
                        <v-list-item-action>
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Minha Conta</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <div class="px-2">
                        <v-btn
                            block
                            @click="logout"
                            data-cy="logout"
                            :loading="load_logout"
                            :color="colorBotaoSair"
                        >
                            sair
                            <v-icon class="ml-2">mdi-logout</v-icon>
                        </v-btn>
                    </div>
                    <v-card-text
                        class="grey--text text--darken-2 text-center"
                        :style="sidebarTextStyle"
                    >
                        Versão: {{ version }}
                    </v-card-text>
                </div>
            </template>
        </v-navigation-drawer>
        <v-app-bar
            v-show="isAuthenticated"
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            :color="colorBar"
            dark
            :dense="!computedGetPartner"
            data-cy="homeToolbar"
            :class="
                $vuetify.breakpoint.lgAndUp && !computedGetPartner
                    ? ''
                    : 'mobile-toolbar'
            "
        >
            <!-- <v-toolbar-title> -->
            <!-- <v-layout> -->
            <v-app-bar-nav-icon
                @click.stop="changeDrawer"
                :class="computedGetPartner ? 'grey--text text--darken-2' : ''"
                :style="headerTextStyle"
            ></v-app-bar-nav-icon>

            <router-link
                to=""
                style="display: flex; justify-content: center; align-items: center"
            >
                <v-img
                    v-if="usuarioRecuperi"
                    data-cy="logoHeader"
                    :src="logo"
                    alt="logo-recuperi"
                    :width="wlLogoWidth"
                />
                <v-img
                    v-if="usuarioPartner && $vuetify.breakpoint.lgAndUp"
                    data-cy="logoHeader"
                    :src="logoRecuperiAlt"
                    alt="logo-recuperi-alt"
                    width="120px"
                    class="mr-2"
                />
                <v-img
                    v-if="usuarioPartner"
                    :src="logoBvs"
                    alt="logo-bvs"
                    width="210px"
                />
            </router-link>
            <v-switch
                v-if="
                    usuarioRecuperi &&
                        $vuetify.breakpoint.lgAndUp
                "
                v-model="versaoBeta"
                class="ml-2"
                label="Beta"
                color="red"
                data-cy="switchBeta"
                @click="setVersaoBeta()"
                hide-details
            ></v-switch>
            <v-btn
                v-if="avisoHomologacao"
                class="success ml-4 mt-3 font-weight-black"
                small
            >
                <v-icon x-small>mdi-information-outline</v-icon>homologação
            </v-btn>
            <!-- </v-layout> -->
            <!-- </v-toolbar-title> -->
            <v-spacer v-if="$vuetify.breakpoint.lgAndUp"></v-spacer>
            <div
                v-if="
                    userProfile && superUsuario && $vuetify.breakpoint.lgAndUp
                "
                class="title-apresentante cursor-pointer"
                data-cy="alterar-apresentante"
                @click="alterarApresentante"
            >
                {{ userProfile.cd_apresentante }} -
                {{ userProfile.nm_apresentante }}
                <div class="title-apresentante-cnpj">
                    {{ this.formatCnpj(userProfile.nu_cnpj) }}
                </div>
            </div>
            <div
                v-if="
                    userProfile && !superUsuario && $vuetify.breakpoint.lgAndUp
                "
                class="title-apresentante cursor-pointer"
                :class="computedGetPartner ? 'grey--text text--darken-2' : ''"
                :style="headerTextStyle"
            >
                {{ userProfile.cd_apresentante }} -
                {{ userProfile.nm_apresentante }}
                <div class="title-apresentante-cnpj">
                    {{ this.formatCnpj(userProfile.nu_cnpj) }}
                </div>
            </div>
            <v-spacer v-if="$vuetify.breakpoint.lgAndUp"></v-spacer>
            <div v-if="$vuetify.breakpoint.lgAndUp">
                <v-menu offset-y>
                    <template
                        v-slot:activator="{
                            on,
                            attrs
                        }"
                    >
                        <v-btn
                            :color="wlHeaderBtnColor"
                            x-small
                            class="ma-2"
                            fab
                            v-bind="attrs"
                            v-on="on"
                            :outlined="computedGetPartner || wlBtnOutlined"
                        >
                            <v-icon class="">mdi-bell-badge</v-icon>
                        </v-btn>
                    </template>
                    <v-list
                        max-width="400px"
                        max-height="500px"
                        style="overflow-y: auto;"
                        :class="{
                            'grey lighten-4':
                                carregandoNotificacoes &&
                                itemsNotification.length > 0
                        }"
                    >
                        <v-list-item
                            v-if="
                                itemsNotification.length === 0 &&
                                    !carregandoNotificacoes
                            "
                        >
                            <v-list-item-title
                                class="ma-2 text-center grey--text"
                            >
                                Nenhuma divulgação disponível
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="carregandoNotificacoes">
                            <v-list-item-title class="ma-2 text-center">
                                <v-progress-circular
                                    indeterminate
                                    size="20"
                                    class="mr-2"
                                ></v-progress-circular>
                                Carregando...
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-for="(item, index) in itemsNotification"
                            :key="index"
                            :class="{
                                'grey--text text--lighten-1': carregandoNotificacoes
                            }"
                            :disabled="carregandoNotificacoes"
                        >
                            <v-list-item-content
                                class="ma-2"
                                :class="{
                                    'grey--text text--lighten-1': carregandoNotificacoes
                                }"
                            >
                                <v-list-item-title
                                    class="font-weight-bold"
                                    :class="{
                                        'grey--text text--lighten-1': carregandoNotificacoes
                                    }"
                                >
                                    {{ item.assunto }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    v-if="item.data_envio"
                                    class="caption"
                                    :class="
                                        carregandoNotificacoes
                                            ? 'grey--text text--lighten-2'
                                            : 'grey--text'
                                    "
                                >
                                    Publicado em:
                                    {{ formatarData(item.data_envio) }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-dialog
                                transition="dialog-top-transition"
                                max-width="800"
                            >
                                <template
                                    v-slot:activator="{
                                        on,
                                        attrs
                                    }"
                                >
                                    <v-btn
                                        small
                                        elevation="0"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="carregandoNotificacoes"
                                        :class="{
                                            'grey--text text--lighten-1': carregandoNotificacoes
                                        }"
                                    >
                                        <v-icon>mdi-chevron-right</v-icon>
                                        Ver detalhes
                                    </v-btn>
                                </template>
                                <template v-slot:default="dialog">
                                    <v-card>
                                        <v-toolbar color="primary" dark>
                                            <v-card-title
                                                class="font-weight-black"
                                                >{{
                                                    item.assunto
                                                }}</v-card-title
                                            >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                icon
                                                @click="dialog.value = false"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text
                                            class="text-center pa-4"
                                            v-if="item.imagem_url"
                                        >
                                            <div
                                                class="position-relative d-inline-block"
                                            >
                                                <v-img
                                                    :src="item.imagem_url"
                                                    max-width="700"
                                                    max-height="500"
                                                    contain
                                                    class="mx-auto rounded cursor-pointer"
                                                    @click="
                                                        expandirImagem(item)
                                                    "
                                                ></v-img>
                                            </div>
                                            <div
                                                class="mt-2 caption grey--text"
                                            >
                                                Clique na imagem para expandir
                                            </div>
                                        </v-card-text>
                                        <v-divider
                                            v-if="item.imagem_url"
                                        ></v-divider>
                                        <v-card-text
                                            v-if="item.data_envio"
                                            class="pb-2"
                                        >
                                            <strong>Data de envio:</strong>
                                            {{ formatarData(item.data_envio) }}
                                        </v-card-text>
                                        <v-card-text
                                            v-if="item.user"
                                            class="pt-2"
                                        >
                                            <strong>Enviado por:</strong>
                                            {{ item.user.nm_user }} ({{
                                                item.user.ds_email
                                            }})
                                        </v-card-text>
                                        <v-card-actions class="justify-end">
                                            <v-btn
                                                text
                                                @click="dialog.value = false"
                                                >fechar</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </v-list-item>

                        <!-- Footer com controles de paginação sempre visível -->
                        <v-divider></v-divider>
                        <v-list-item class="pa-2">
                            <v-row
                                no-gutters
                                align="center"
                                justify="space-between"
                                class="px-2"
                            >
                                <v-col cols="auto">
                                    <v-btn
                                        small
                                        outlined
                                        color="primary"
                                        :disabled="
                                            paginaAtualNotificacoes <= 1 ||
                                                carregandoNotificacoes
                                        "
                                        @click.stop="carregarPaginaAnterior"
                                        class="px-2"
                                    >
                                        <v-icon small>mdi-chevron-left</v-icon>
                                        Anterior
                                    </v-btn>
                                </v-col>
                                <v-col class="text-center">
                                    <div class="caption font-weight-bold">
                                        Página {{ paginaAtualNotificacoes }} de
                                        {{ totalPaginasNotificacoes }}
                                    </div>
                                    <div class="caption grey--text">
                                        {{ totalItensNotificacoes }} divulgações
                                    </div>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn
                                        small
                                        outlined
                                        color="primary"
                                        :disabled="
                                            paginaAtualNotificacoes >=
                                                totalPaginasNotificacoes ||
                                                carregandoNotificacoes
                                        "
                                        @click.stop="carregarProximaPagina"
                                        class="px-2"
                                    >
                                        Próxima
                                        <v-icon small>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <!-- Modal para expandir imagem -->
            <v-dialog
                v-model="dialogImagemExpandida"
                max-width="90vw"
                max-height="90vh"
                overlay-opacity="0.9"
            >
                <v-card v-if="imagemSelecionada" class="pa-0">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>{{
                            imagemSelecionada.assunto
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="fecharImagemExpandida">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-4">
                        <v-img
                            :src="imagemSelecionada.imagem_url"
                            contain
                            style="max-height: 70vh; margin: auto;"
                            class="mx-auto"
                        ></v-img>
                    </v-card-text>
                    <v-card-actions class="justify-center pa-2">
                        <v-btn text @click="fecharImagemExpandida">
                            Fechar
                        </v-btn>
                        <v-btn text @click="baixarImagem(imagemSelecionada)">
                            <v-icon left>mdi-download</v-icon>
                            Baixar Imagem
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <div v-if="$vuetify.breakpoint.lgAndUp">
                <v-btn
                    v-if="isSuperUser"
                    @click="dialogModalRelatorios = true"
                    :color="wlHeaderBtnColor"
                    small
                    class="mx-2"
                    data-cy="btnRelatorios"
                >
                    Relatórios
                    <v-icon small class="mx-2">mdi-file-chart-outline</v-icon>
                </v-btn>
            </div>
            <div v-if="$vuetify.breakpoint.lgAndUp && !isSocialUser">
                <v-btn
                    @click="minhaConta"
                    :color="wlHeaderBtnColor"
                    small
                    class="mx-2"
                    :outlined="computedGetPartner || wlBtnOutlined"
                >
                    Minha Conta
                    <v-icon small class="mx-2">mdi-account</v-icon>
                </v-btn>
            </div>

            <div v-if="$vuetify.breakpoint.lgAndUp && isSocialUser">
                <v-btn
                    @click="socialUserAlterarEmpresa"
                    :color="wlHeaderBtnColor"
                    small
                    class="mx-2"
                >
                    Alterar Empresa
                    <v-icon small class="mx-2">mdi-swap-horizontal</v-icon>
                </v-btn>
            </div>

            <div class="">
                <v-btn
                    :loading="load_logout"
                    small
                    :color="wlHeaderBtnColor"
                    @click="logout"
                    class="mx-2"
                    data-cy="logoutToolBar"
                    :rounded="$vuetify.breakpoint.smAndDown"
                    :outlined="computedGetPartner || wlBtnOutlined"
                >
                    {{ $vuetify.breakpoint.lgAndUp ? 'Sair' : '' }}
                    <v-icon small class="mx-2">mdi-exit-to-app</v-icon>
                </v-btn>
            </div>
            <ModalRelatoriosSolicitados
                v-if="dialogModalRelatorios"
                :dialogModalRelatorios="dialogModalRelatorios"
                @fecharModal="dialogModalRelatorios = false"
            />
        </v-app-bar>
        <v-row
            class="btn-troca-apresentante ma-0"
            v-if="
                $vuetify.breakpoint.smAndDown &&
                    shouldShowRow &&
                    isAuthenticated
            "
            :style="
                computedGetPartner
                    ? 'background: #333E48;'
                    : wlPanelColor
                    ? `background: ${wlPanelColor}`
                    : ''
            "
        >
            <div
                v-if="userProfile && superUsuario"
                class="title-apresentante-m cursor-pointer"
                data-cy="alterar-apresentante"
                @click="alterarApresentante"
            >
                {{ userProfile.cd_apresentante }} -
                {{ userProfile.nm_apresentante }}
            </div>
            <div
                v-if="userProfile && !superUsuario"
                class="title-apresentante cursor-pointer"
            >
                {{ userProfile.cd_apresentante }} -
                {{ userProfile.nm_apresentante }}
                <div class="title-apresentante-cnpj">
                    {{ this.formatCnpj(userProfile.nu_cnpj) }}
                </div>
            </div>
        </v-row>
        <LembreteExpiracaoSenha />
        <SocialUserModalAlterarUsuario
            :showModal="showAlterarEmpresa"
            @fechar="showAlterarEmpresa = false"
        />
    </span>
</template>

<script>
import menuPartner from '@/helpers/MenuPartner';
import MenuRecuperi from '@/helpers/MenuRecuperi';
import { listarSituacoesTitulo } from '@/helpers/Utilitarios';
import ModalRelatoriosSolicitados from '@/modals/ModalRelatoriosSolicitados';
import router from '@/router';
import DivulgacaoService from '@/services/DivulgacaoService';
import Vue from 'vue';
import versionInfo from '../helpers/VERSION.md';
import LembreteExpiracaoSenha from './LembreteExpiracaoSenha.vue';
import SocialUserModalAlterarUsuario from './SocialUserModalAlterarUsuario.vue';
export default {
    name: 'AppNavigation',
    components: {
        ModalRelatoriosSolicitados,
        LembreteExpiracaoSenha,
        SocialUserModalAlterarUsuario
    },
    data: () => ({
        shouldShowRow: true,
        prevScrollY: 0,
        versaoBeta: false,
        version: versionInfo,
        dialogModalRelatorios: false,
        loadingIcon: true,
        avisoHomologacao: false,
        colorBar: 'primary',
        usuarioLite: false,
        usuarioBasic: false,
        usuarioAdmin: false,
        superUsuario: false,
        admins: [
            ['Management', 'mdi-account-multiple-outline'],
            ['Settings', 'mdi-cog-outline']
        ],
        cruds: [
            ['Create', 'mdi-plus-outline'],
            ['Read', 'mdi-file-outline'],
            ['Update', 'mdi-update'],
            ['Delete', 'mdi-delete']
        ],
        drawer: true,
        itemsNotification: [],
        paginaAtualNotificacoes: 1,
        totalPaginasNotificacoes: 1,
        totalItensNotificacoes: 0,
        carregandoNotificacoes: false,
        dialogImagemExpandida: false,
        imagemSelecionada: null,
        menusRecuperi: MenuRecuperi,
        menusPartner: menuPartner,
        load_logout: false,
        logo: require('@/assets/logo-recuperi-2400.png'),
        logoRecuperiAlt: require('@/assets/logo-recuperi-2.png'),
        logoBvs: require('@/assets/logo-recuperi-equifax.png'),
        // logoBvs: require('@/assets/logo-recuperi-boa-vista.png'),
        user_profile: {},
        usuarioPartner: false,
        usuarioRecuperi: false,
        colorBotaoSair: null,
        backgroundMenu: require('@/assets/background-menu-recuperi.jpg'),
        sideBarColor: null,
        showAlterarEmpresa: false
    }),
    computed: {
        userProfile() {
            return this.$store.getters.user;
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        computedGetUserName() {
            return this.$store.getters.getUserName;
        },
        computedGetApresentante() {
            return this.$store.getters.cdApresentante;
        },
        computedGetUserEmail() {
            return this.$store.getters.getUserEmail;
        },
        computedGetUserLogin() {
            return this.$store.getters.getUserLogin;
        },
        isSuperUser() {
            if (this.$store.getters.getSuperUser == 1) {
                return true;
            }
            return false;
        },
        computedGetPartner() {
            return this.$store.getters.isPartner == 1;
        },
        situacoesTitulo() {
            return this.$store.getters.situacoesTitulo;
        },
        usuarioAgrupador() {
            return this.$store.getters.agrupadorUsuario;
        },
        apresentanteNotifica() {
            return this.$store.getters.apresentanteNotifica;
        },
        showDrawer: {
            get() {
                if (this.drawer && this.isAuthenticated == true) {
                    return true;
                } else {
                    return false;
                }
            },
            set() {
                this.drawer = this.drawer;
            }
        },
        isUserReadonly() {
            return this.$store.getters.isUserReadonly;
        },
        isApresentanteCraNacional() {
            return this.$store.getters.isApresentanteCraNacional;
        },
        isSocialUser() {
            try {
                return this.$store.getters.user.user_social;
            } catch (e) {
                return false;
            }
        },
        wlHeaderBtnColor() {
            const headerBtnColor = this.userProfile?.ds_identidade_visual
                ?.header_btn_color
                ? this.userProfile.ds_identidade_visual.header_btn_color
                : this.colorBotaoSair
                ? this.colorBotaoSair
                : null;
            return headerBtnColor;
        },
        wlHeaderTextColor() {
            const headerTextColor = this.userProfile?.ds_identidade_visual
                ?.header_text_color
                ? this.userProfile.ds_identidade_visual.header_text_color
                : null;
            return headerTextColor;
        },
        wlSidebarTextcolor() {
            const sidebarTextColor = this.userProfile?.ds_identidade_visual
                ?.sidebar_text_color
                ? this.userProfile.ds_identidade_visual.sidebar_text_color
                : null;
            return sidebarTextColor;
        },
        headerTextStyle() {
            if (!this.computedGetPartner && this.wlHeaderTextColor) {
                return { color: `${this.wlHeaderTextColor} !important` };
            }
            // return { color: 'white' };
            return '';
        },
        sidebarTextStyle() {
            if (!this.computedGetPartner && this.wlSidebarTextcolor) {
                return { color: `${this.wlSidebarTextcolor} !important` };
            }
            // return { color: 'white' };
            return '';
        },
        wlBtnOutlined() {
            const btnOutlined = this.userProfile?.ds_identidade_visual
                ?.btn_outlined
                ? this.userProfile.ds_identidade_visual.btn_outlined
                : false;
            return btnOutlined;
        },
        wlLogoWidth() {
            const logoWidth = this.userProfile?.ds_identidade_visual?.logo_width
                ? this.userProfile.ds_identidade_visual.logo_width
                : '150px';
            return logoWidth;
        },
        wlPanelColor() {
            const panelColor = this.userProfile?.ds_identidade_visual
                ?.panel_color
                ? this.userProfile.ds_identidade_visual.panel_color
                : null;
            return panelColor;
        },
        hasWebhookCallback() {
            return !!this.$store.getters.callbackUrlEndpoint;
        }
    },
    methods: {
        listarSituacoesTitulo,
        expandirImagem(item) {
            this.imagemSelecionada = item;
            this.dialogImagemExpandida = true;
        },
        fecharImagemExpandida() {
            this.dialogImagemExpandida = false;
            this.imagemSelecionada = null;
        },
        async baixarImagem(item) {
            try {
                const response = await fetch(item.imagem_url);
                const blob = await response.blob();

                // Criar um link temporário para download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                // Extrair nome do arquivo da URL ou usar um nome padrão
                const urlParts = item.imagem_url.split('/');
                const fileName =
                    urlParts[urlParts.length - 1] ||
                    `divulgacao_${item.id}.${blob.type.split('/')[1]}`;

                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                // Limpar
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Erro ao baixar imagem:', error);
                // Fallback para o método tradicional se houver erro
                window.open(item.imagem_url, '_blank');
            }
        },
        async carregarDivulgacoes(pagina = 1) {
            try {
                this.carregandoNotificacoes = true;
                const divulgacaoService = new DivulgacaoService(
                    this.$http,
                    this.$store
                );
                const response = await divulgacaoService.listarDivulgacoes(
                    {
                        status: 'enviado',
                        ativo: true,
                        expira_em: new Date().toISOString()
                    }, // Filtrar apenas divulgações enviadas, ativas e não expiradas
                    pagina, // página
                    5, // itens por página
                    'data_envio', // ordenar por data de envio
                    true // ordem decrescente (mais recentes primeiro)
                );

                this.itemsNotification = response.data.results || [];
                this.paginaAtualNotificacoes = pagina;
                this.totalItensNotificacoes = response.data.total_results || 0;
                this.totalPaginasNotificacoes = response.data.total_pages || 1;
            } catch (error) {
                console.error('Erro ao carregar divulgações:', error);
                this.itemsNotification = [];
                this.paginaAtualNotificacoes = 1;
                this.totalPaginasNotificacoes = 1;
                this.totalItensNotificacoes = 0;
            } finally {
                this.carregandoNotificacoes = false;
            }
        },
        async carregarProximaPagina() {
            if (
                this.paginaAtualNotificacoes < this.totalPaginasNotificacoes &&
                !this.carregandoNotificacoes
            ) {
                await this.carregarDivulgacoes(
                    this.paginaAtualNotificacoes + 1
                );
            }
        },
        async carregarPaginaAnterior() {
            if (
                this.paginaAtualNotificacoes > 1 &&
                !this.carregandoNotificacoes
            ) {
                await this.carregarDivulgacoes(
                    this.paginaAtualNotificacoes - 1
                );
            }
        },
        formatarData(dataString) {
            if (!dataString) return '';
            const data = new Date(dataString);
            return data.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatCnpj(cnpj) {
            if (!cnpj) {
                return '';
            }
            const stripped = cnpj.replace(/[^a-zA-Z0-9]/g, '');
            if (stripped.length !== 14) return cnpj;
            return stripped.replace(
                /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
                '$1.$2.$3/$4-$5'
            );
        },
        handleScroll() {
            const scrollPosition = window.scrollY || window.pageYOffset;

            // Verificar se o scroll está indo para cima
            if (scrollPosition < 200 || scrollPosition < this.prevScrollY) {
                this.shouldShowRow = true;
            } else {
                this.shouldShowRow = false;
            }

            // Atualizar a posição anterior do scroll
            this.prevScrollY = scrollPosition;
        },
        setVersaoBeta() {
            // this.versaoBeta = !this.versaoBeta;
            this.$store.dispatch('setVersaoBeta', this.versaoBeta);
        },
        getValorDataCypress(item) {
            const path = item.path.replaceAll('/', '');
            return `path${path}`;
        },
        logout() {
            this.load_logout = true;
            this.$store.dispatch('userLogout');
            router.push('/login');
            this.load_logout = false;
            //seta o drawer para true apenas para que quando o usuário logue novamente, ele ja venha aberto
            this.drawer = true;
        },
        validarMenuByUsuario(item) {
            let validouMenu = true;
            if (item.hide && item.hide.length > 0) {
                for (let index = 0; index < item.hide.length; index++) {
                    const tipoUsuario = item.hide[index];
                    const tiposUsuario = tipoUsuario.split(' ');

                    if (
                        item.path == '/alteracoes-em-lote' &&
                        this.usuarioBasic &&
                        !this.isApresentanteCraNacional
                    ) {
                        return false;
                    }

                    if (tiposUsuario?.length > 1) {
                        if (this.usuarioAdmin && !this.superUsuario) {
                            validouMenu = false;
                            break;
                        }
                    } else {
                        if (this[tipoUsuario]) {
                            validouMenu = false;
                            break;
                        }
                    }
                }
            }
            return validouMenu;
        },
        validarMenuUsuarioAgrupador(menu) {
            if (!this.usuarioAgrupador) {
                return true;
            }

            var proibidosAgrupador = [
                '/upload-titulos',
                '/agrupador-em-massa',
                '/listar-agrupadores',
                '/listar-usuarios',
                '/'
            ];

            if (this.$store.getters.isAdmin == 1) {
                proibidosAgrupador = [
                    '/agrupador-em-massa',
                    '/listar-agrupadores',
                    '/listar-usuarios',
                    '/'
                ];
            }

            if (proibidosAgrupador.includes(menu.path)) {
                return false;
            }

            return true;
        },
        validarMenuPorApresentante(menu) {
            if (this.computedGetApresentante === 'TST') {
                const proibidosTST = ['/documentacao-api'];
                if (proibidosTST.includes(menu.path)) {
                    return false;
                }
            }

            if (menu.path === '/webhooks' && !this.isSuperUser && !this.hasWebhookCallback) {
                return false;
            }

            return true;
        },
        isShowItem(item, authenticated) {
            if (item.authRequired && !authenticated) {
                return false;
            } else {
                if (
                    !this.validarMenuPorApresentante(item) ||
                    !this.validarMenuByUsuario(item) ||
                    !this.validarMenuUsuarioAgrupador(item)
                ) {
                    return false;
                }

                return true;
            }
        },
        returnHome() {
            return router.push('/');
        },
        changeDrawer() {
            this.drawer = !this.drawer;
        },
        minhaConta() {
            return router.push('/minha-conta');
        },

        socialUserAlterarEmpresa() {
            this.showAlterarEmpresa = true;
        },

        alterarApresentante() {
            if (this.superUsuario) {
                router.push('/trocar-apresentante');
            }
            return;
        },
        applyUserTheme() {
            const visual = this.userProfile?.ds_identidade_visual ?? {};
            const defaults = {
                primary: '#26c6da',
                secondary: '#00acc1',
                url_logo: require('@/assets/logo-recuperi-2400.png')
            };

            const theme = { ...defaults, ...visual };

            this.$vuetify.theme.themes.light.primary = theme.primary;
            this.$vuetify.theme.themes.light.secondary = theme.secondary;
            this.colorBotaoSair = theme.btn_color || theme.primary;
            this.logo = theme.url_logo || defaults.url_logo;
            this.sideBarColor = theme.sidebar_color || null;
            this.colorBar = theme.header_color || theme.primary;
        },
        constructor() {
            this.versaoBeta = this.$store.getters.isBetaVersion;
            if (document.location.href.indexOf('painel-hom.recuperi') > -1) {
                this.avisoHomologacao = true;
                this.colorBar = 'secondary';
            }
            if (this.$store.getters.isLite == 1) {
                this.usuarioLite = true;
                this.usuarioBasic = false;
            } else {
                this.usuarioLite = false;
                this.usuarioBasic = true;
            }
            if (this.$store.getters.isPartner == 1) {
                this.usuarioPartner = true;
                this.usuarioRecuperi = false;
                this.backgroundMenu = null;
                this.sideBarColor = 'white';
                this.colorBar = 'white';
                this.$vuetify.theme.themes.light.primary = '#007298';
                this.$vuetify.theme.themes.light.secondary = '#fbc93b';
                this.colorBotaoSair = '#007298';
            } else {
                this.usuarioRecuperi = true;
                if (this.userProfile && this.userProfile.ds_identidade_visual) {
                    this.backgroundMenu = null;
                }
                this.applyUserTheme();
            }
            if (this.$store.getters.getSuperUser == 1) {
                this.superUsuario = true;
            } else {
                this.superUsuario = false;
            }
            if (this.$store.getters.isAdmin == 1) {
                this.usuarioAdmin = true;
                this.usuarioBasic = false;
            } else {
                this.usuarioAdmin = false;
            }
        }
    },
    created() {
        setTimeout(() => {
            this.loadingIcon = false;
        }, 2000);
    },
    mounted() {
        this.constructor();
        window.addEventListener('scroll', this.handleScroll);
        this.drawer =
            this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
                ? false
                : true;
        listarSituacoesTitulo(Vue.http, this.$store);
        this.carregarDivulgacoes();
    },
    beforeUpdate() {
        this.constructor();
    }
};
</script>
<style lang="scss">
.v-main__wrap {
    @media only screen and (max-width: 800px) {
        padding-top: 30px;
    }
}

.btn-troca-apresentante {
    background-color: #26c6da;
    color: white;
    font-size: 12px !important;
    width: 100%;
    top: 48px;
    position: fixed;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid #e0e0e0;
}
.title-apresentante {
    font-size: 16px;
    font-weight: bold;
}
.title-apresentante-cnpj {
    text-align: center;
    font-size: 13px;
}
.cursor-pointer {
    cursor: pointer;
}

/* Hover effect para a imagem dentro dos modais de divulgação */
.v-dialog .v-image.cursor-pointer:hover {
    transform: scale(1.02);
    transition: transform 0.3s ease;
}

/* Estilos específicos para o menu de notificações */
.v-menu__content .v-list .v-list-item.pa-2 {
    min-height: 48px;
    background-color: #f5f5f5;
}

.v-menu__content .v-list .v-list-item .v-btn--icon.small {
    width: 28px;
    height: 28px;
}

.v-menu__content .v-list .v-list-item .v-btn.small {
    font-size: 12px;
    min-width: 80px;
    height: 32px;
    font-weight: 500;
}

.v-menu__content .v-list .v-list-item .v-btn.small .v-icon {
    font-size: 16px;
}

/* Destaque para o footer de paginação das notificações */
.v-menu__content .v-list .v-list-item:last-child {
    border-top: 1px solid #e0e0e0;
}

.mobile-toolbar .v-toolbar__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
